<div id="container">
  <highcharts-chart
    [Highcharts]="Highcharts"
    [options]="gaugeChart"
    style="width: 300px; height: 300px; display: block;"
  ></highcharts-chart>
</div>